import { useState } from 'react';

/**
 * @returns {readonly [boolean, () => void, () => void, () => void]} A tuple, so
 * callers destructuring `[isOpen, open, close, toggle]` get each element's own
 * type. Inferred, the return is `(boolean | (() => void))[]`, which makes every
 * destructured name the union of all four.
 */
export const useModal = (initialMode = false) => {
  const [isModalOpen, setModalState] = useState(initialMode);
  const setModalOpen = () => setModalState(true);
  const setModalClose = () => setModalState(false);
  const toggle = () => setModalState(!isModalOpen);

  return [isModalOpen, setModalOpen, setModalClose, toggle];
};
